import { SitesApiResponse } from "../types/site";

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || "https://bagr.iprosystems.com/api";
const API_KEY = import.meta.env.VITE_API_KEY;
const SITE_ID = import.meta.env.VITE_SITE_ID || "marketplacedev";

export async function fetchSiteInfo(): Promise<SitesApiResponse> {
  const url = new URL(`${API_BASE_URL}/sites`);
  url.searchParams.append("populate", "*");
  url.searchParams.append("filters[SiteID][$eq]", SITE_ID);

  const headers: HeadersInit = {
    "Content-Type": "application/json",
  };

  if (API_KEY) {
    headers["Authorization"] = `Bearer ${API_KEY}`;
  }

  const response = await fetch(url.toString(), {
    method: "GET",
    headers,
  });

  if (!response.ok) {
    throw new Error(`Failed to fetch site info: ${response.status} ${response.statusText}`);
  }

  return response.json();
}
